export default async function postReporteEstadisticas(body) {
  const endpoint = localStorage.getItem("api");
  const url = endpoint + "statistics";

  const header = {
    "Content-Type": " application/json",
  };
  const js = JSON.stringify(body);
  try {
    const config = { method: "POST", headers: header, body: js };
    const response = await fetch(url, config);
    const json = await response.json();
    return json;
  } catch (error) {
    console.log("Error" + error);
  }
}
